// extracted by mini-css-extract-plugin
module.exports =  {"loader":"ProjectPage__loader--BD","morePopupItemClassName":"ProjectPage__morePopupItemClassName--mG"};